import React from "react";
import CommonCard from "components-v2/kpi/common-card";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";
import { DisplayAmount } from "components/display/amount";

import { HOME_CARD_CONTENT } from "@/modules/home/constants";
import { ShimmerEffect } from "@/components/shimmer";

export default function BusinessGenerationCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["am-owned-revenue", tagId],
    queryFn: async () => {
      const endpoint = "kpi/am-owned-revenue";
      const response = await apiRoot.get(endpoint, {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const amount = data?.amount ?? 0;

  const { title, description } = HOME_CARD_CONTENT.businessGeneration;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : parseFloat(amount).toFixed(2),
        unit: "",
      }}
    >
      <div className="text-3xl font-bold mt-2">
        {isLoading ? (
          <ShimmerEffect className="h-10 w-32" />
        ) : (
          <DisplayAmount value={amount} />
        )}
      </div>
    </CommonCard>
  );
}
